import React, { useCallback, useContext, useEffect, useState } from "react";
import { Text, View, StyleSheet, ScrollView, FlatList } from "react-native";

import { AuthContext } from "../../contexts/auth/Store";
import { ProductContext } from "../../contexts/product/Store";
import { AnalyticsService } from "../../constants/Analytics";
import GridView from "../../components/product/GridView";
import Colors from "../../constants/Colors";
import { IManufacturer } from "../../interfaces/manufacturer";
import { useFocusEffect, useNavigation } from "@react-navigation/native";

const analytics = new AnalyticsService();

function ManufacturerScreen() {
  const navigation = useNavigation();
  const auth: any = useContext(AuthContext);
  const buyer = auth.getUserData.buyerData;

  const { product_state, fetch_next_manufacturer } = useContext(ProductContext);
  const [manufacturers, setManufacturers] = useState([]);

  const nav_handler = (manufacturer: IManufacturer) => {
    if (manufacturer._id === "manufacturer_001") {
      navigation.navigate("ProductExplore");
    } else {
      navigation.navigate("ManufacturerBrand", {
        id: manufacturer._id,
      });
    }
  };

  useEffect(() => {
    try {
      if (product_state?.manufacturers.length) {
        setManufacturers([
          {
            _id: "manufacturer_001",
            upload: { path: "2020/11/default" },
            name: "All Products",
          },
          ...product_state.manufacturers,
        ]);
      }
    } catch (e) {
      console.log(e);
    }
    return () => {
      // cleanup
    };
  }, [product_state.manufacturers]);

  useFocusEffect(
    useCallback(() => {
      analytics.logEvent("Viewed Manufacturers", auth.getUserData.buyerData);
      analytics.googleHelpers.setCurrentScreen(
        "ViewedManufacturers",
        "ViewedManufacturers"
      );

      fetch_next_manufacturer()
        .then((res) => {})
        .catch((err) => {});
      return () => {};
    }, [])
  );

  return (
    <>
      <View style={styles.container}>
        {product_state.loading_next_manufacturer && !manufacturers.length ? (
          <FlatList
            initialNumToRender={10}
            data={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
            renderItem={({ item, index }) => (
              <GridView index={index} model={item} key={index} />
            )}
            keyExtractor={(item) => `${item}`}
            key={3}
            numColumns={3}
            contentContainerStyle={styles.scrollView}
          />
        ) : (
          <FlatList
            initialNumToRender={10}
            data={manufacturers}
            renderItem={({ item, index }) => (
              <GridView
                index={index}
                model={item}
                key={index}
                action={() => nav_handler(item)}
                rounded={true}
              />
            )}
            keyExtractor={(item) => item._id}
            key={3}
            numColumns={3}
            contentContainerStyle={styles.scrollView}
            onEndReached={() => {
              fetch_next_manufacturer()
                .then((res) => {})
                .catch((err) => {});
            }}
            onEndReachedThreshold={2}
          />
        )}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.whiteColor,
  },
  scrollView: {
    backgroundColor: Colors.whiteColor,
  },
});

export default ManufacturerScreen;
